// extracted by mini-css-extract-plugin
module.exports = {"logo":"App_logo__1ItuU","site-layout":"App_site-layout__3bQeT","site-layout-background":"App_site-layout-background__3cWFB"};